import DomCreator from '../util/DomCreator';
import anime from 'animejs';

var Iframe = {
  getIframeWidth() {
    const ref = document.querySelector('.js-header');

    if (typeof ref !== 'undefined' && ref.offsetWidth) {
      return ref.offsetWidth
    }

    return 1000;
  },
  setRatio(heightRatio) {
    if (typeof heightRatio != 'number') {
      heightRatio = 0.56;
    }

    let iframes = document.querySelectorAll('.iframe');
    const width = this.getIframeWidth();

    iframes.forEach( iframe => {
      iframe.width = width + 'px';
      iframe.height = (width * heightRatio) + 'px';
    });
  },
  bindImporters() {
    const $triggers = Array.from(document.querySelectorAll('.js-iframe-loader'));

    $triggers.map( $trigger => $trigger.addEventListener('click', () => {
      const $container = $trigger.parentNode.querySelector('.js-iframe-container');
      if (!$container.classList.contains('expand')) {
        if (!$container.classList.contains('loaded')) {
          $container.classList.add('expand');
          const iframe = DomCreator.iframe($trigger.dataset.src, () => {
            $container.classList.add('loaded');
          });
          $container.appendChild(iframe);
        } else {
          $container.classList.add('expand');
        }
      } else {
        $container.classList.remove('expand');
      }
    }));
  },

  bindLoadMore() {
    const $trigger = document.querySelector('.js-load-more-iframes');

    if (!$trigger) return false;

    $trigger.addEventListener('click', () => {
      const $iframes = Array.from(document.querySelectorAll('.js-iframe.hidden'));
      for(let i = 0; i < $trigger.dataset.load; i++) {
        const iframe = $iframes[i];
        iframe.classList.remove('hidden');
        anime({
          targets: iframe,
          opacity: [0, 1],
          translateY: ['-1rem', '0rem'],
          duration: 250,
          delay: 50 * i,
          easing: 'linear',
        });

        if(document.querySelectorAll('.js-iframe.hidden').length === 0) {
          $trigger.classList.add('hidden');
        }
      }
    });
  },
}

export default Iframe;



// WEBPACK FOOTER //
// ./scripts/dom/Iframes.js